import React from 'react';
import StackedChartComponent from "../commons/StackedChartComponent";
import ClusteredBarChartComponent from "../commons/ClusteredBarChartComponent";

function SelectsChartComponent(props){
    const isMultipleMatrix = props.questionData.question.options.multiple ?
        props.questionData.question.options.multiple : false;

    return(
        <React.Fragment>
            {props.viewType === 'Stacked' &&
            <StackedChartComponent
                chartConfig={props.configuration}
                answersData={props.questionAnswers}
                sortingOptions={props.sortingOptions}
                questionId={props.questionData.question.question_id}
                questionTitle={props.questionData.question.id + ". " + props.questionData.question.question}
                questionSelects={props.questionData.question.selects}
                isMobile={props.isMobile}
                chartIndex={props.chartIndex}
                updateChartInfo={props.updateChartInfo}/>}
            {props.viewType === 'Clustered' &&
            <ClusteredBarChartComponent
                chartConfig={props.configuration}
                answersData={props.questionAnswers}
                sortingOptions={props.sortingOptions}
                questionId={props.questionData.question.question_id}
                questionTitle={props.questionData.question.id + ". " + props.questionData.question.question}
                questionSelects={props.questionData.question.selects}
                isMultipleMatrix={isMultipleMatrix}
                isMobile={props.isMobile}
                chartIndex={props.chartIndex}
                updateChartInfo={props.updateChartInfo}/>}
        </React.Fragment>);
}

export default SelectsChartComponent;